export const EN_GB_TRANSLATIONS = {
  text: {
    therapist: "therapist",
    mindfulness_coach: "mindfulness coach",
    provider: "provider",
    psychiatrist: "psychiatrist",
    faculty: "faculty",
    student: "student",
    resident: "resident",
    zip: "postcode / zip",
    state: "region",
    max_length: '8',
    user: {
      ethnicity: {
        "Black or African American": "Black British",
        "Asian American": "Asian British",
        "Indigenous American": "Indigenous",
        "West Indian Caribbean": "Caribbean"
      }
    }
  },
  datetimeFormats: {
    numeric: {
      year: "numeric",
      month: "numeric",
      day: "numeric"
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric"
    }
  }
};
